import SimpleEditor from './component/editor/SimpleEditor';
import DateEditor from './component/editor/DateEditor';
import ActionsRenderer from './component/PriceTableBtn';

export default {
    SimpleEditor,
    DateEditor,
    ActionsRenderer,
}